var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompanyInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.57142 1.33251C8.09743 0.889162 8.94657 0.889162 9.45755 1.33251L10.6448 2.34697C10.8703 2.53483 11.2986 2.69263 11.5992 2.69263H12.8766C13.6732 2.69263 14.3269 3.34639 14.3269 4.14292V5.42038C14.3269 5.72096 14.4847 6.14177 14.6726 6.3672L15.687 7.55447C16.1304 8.08048 16.1304 8.92961 15.687 9.4406L14.6726 10.6279C14.4847 10.8533 14.3269 11.2741 14.3269 11.5747V12.8522C14.3269 13.6487 13.6732 14.3024 12.8766 14.3024H11.5992C11.2986 14.3024 10.8778 14.4603 10.6523 14.6481L9.46506 15.6626C8.93905 16.1059 8.08992 16.1059 7.57894 15.6626L6.39162 14.6481C6.16619 14.4603 5.73786 14.3024 5.4448 14.3024H4.12977C3.33324 14.3024 2.67948 13.6487 2.67948 12.8522V11.5672C2.67948 11.2741 2.52919 10.8458 2.34133 10.6279L1.32688 9.43308C0.89104 8.91458 0.89104 8.07297 1.32688 7.55447L2.34133 6.35968C2.52919 6.13425 2.67948 5.71344 2.67948 5.42038V4.15044C2.67948 3.3539 3.33324 2.70015 4.12977 2.70015H5.42977C5.73035 2.70015 6.15116 2.54234 6.37659 2.35448L7.57142 1.33251Z",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.51074 5.60156V9.23106",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.50586 11.5156H8.51323",
    stroke: "#5B6B79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyInfo);
export default __webpack_public_path__ + "static/media/company_info.69894d88de67b3b7a478e9d58afb32b2.svg";
export { ForwardRef as ReactComponent };